export default "__VITE_ASSET__CKuIKwEH__"